import React from 'react'
import CenterBox from './CenterBox.js'

const UnsupportedBrowserMessage = () => (
  <CenterBox>
    Your browser is not supported. Please use Google Chrome, Mozilla Firefox,
    Safari, Microsoft Edge or update your browser to at least version 11.
  </CenterBox>
)

export default UnsupportedBrowserMessage



// WEBPACK FOOTER //
// ./src/components/UnsupportedBrowserMessage.js